export default __webpack_public_path__ + "static/media/Footpad's Gloves of the Stolen Kingdom.a1ce92a2.jpg";